import { inject, Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

import { IUserStateService, USER_STATE_SERVICE } from '@shared/state';

import { getFirstPathSegmentFromUrl, shouldPrefixWithActiveOrgSegment } from './org-prefix-route.util';

@Injectable()
export class OrgPrefixUrlSerializer extends DefaultUrlSerializer {
  readonly #userStateService = inject<IUserStateService>(USER_STATE_SERVICE);

  public override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);

    const firstSegment = getFirstPathSegmentFromUrl(url);
    if (!shouldPrefixWithActiveOrgSegment(firstSegment)) {
      return url;
    }
    const orgId = this.#userStateService.getActiveOrgId();
    if (!orgId) return url;

    return `/org/${orgId}${url}`;
  }
}
